import request from '@/utils/request'
import works from './works'
import news from './news'

const apis = {
	install(Vue) {
		works(Vue, request)
		news(Vue, request)
	},
}
export default apis
